interface SkeletonLoaderProps {
  isDarkMode?: boolean;
}

const SkeletonLoader = ({ isDarkMode = false }: SkeletonLoaderProps) => {
  const baseColor = isDarkMode ? 'bg-gray-700' : 'bg-gray-200';

  return (
    <div className="animate-pulse space-y-6">
      {/* Title skeleton */}
      <div className="flex items-center justify-between">
        <div className={`h-8 w-48 rounded-lg ${baseColor}`}></div>
        <div className={`h-10 w-10 rounded-full ${baseColor}`}></div>
      </div>

      {/* Intro text skeleton */}
      <div className={`rounded-xl p-4 ${baseColor}`}>
        <div className="space-y-2">
          <div className={`h-4 rounded ${baseColor} w-full`}></div>
          <div className={`h-4 rounded ${baseColor} w-5/6`}></div>
          <div className={`h-4 rounded ${baseColor} w-4/6`}></div>
        </div>
      </div>

      {/* Tab buttons skeleton */}
      <div className="flex gap-2">
        <div className={`h-16 flex-1 rounded-xl ${baseColor}`}></div>
        <div className={`h-16 flex-1 rounded-xl ${baseColor}`}></div>
        <div className={`h-16 flex-1 rounded-xl ${baseColor} hidden md:block`}></div>
      </div>

      {/* Content cards skeleton */}
      <div className="space-y-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className={`rounded-xl p-4 ${baseColor}`}>
            <div className="flex items-start gap-3">
              <div className={`w-12 h-12 rounded-lg ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'}`}></div>
              <div className="flex-1 space-y-2">
                <div className={`h-5 rounded ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'} w-3/4`}></div>
                <div className={`h-4 rounded ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'} w-full`}></div>
                <div className={`h-4 rounded ${isDarkMode ? 'bg-gray-600' : 'bg-gray-300'} w-5/6`}></div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Shimmer overlay effect */}
      <style>{`
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        .animate-pulse > div {
          background: linear-gradient(90deg, ${isDarkMode ? '#374151' : '#e5e7eb'} 25%, ${isDarkMode ? '#4b5563' : '#f3f4f6'} 50%, ${isDarkMode ? '#374151' : '#e5e7eb'} 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
        }
      `}</style>
    </div>
  );
};

export default SkeletonLoader;
